import React, {Component} from "react";
import Button from "../../../global/generic/Button";

export default class ArrowButton extends Component {
    render() {
        return (
            <div
                id={this.props.id}
                className={"flex " + (this.props.className ?? "")}
                onClick={this.props.onClick}
                {...this.props.elementProps}
            >
                <Button
                    className="svg-only-btn full-height-btn background-darker-blue"
                    label={<span className="glyphicon glyphicon-menu-right" />}
                />
                <Button label={this.props.label} />
            </div>
        );
    }
}
